export default __webpack_public_path__ + "static/JonY-ebf7e26b2c6cd8c332853bd0af4475e5.png";